// test2869
(2869 && 0);
